var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7137_2428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4002 14.8585V14.3335C8.5752 14.2585 7.9752 13.9585 7.4502 13.5835C7.0002 13.2085 6.7002 12.7585 6.7002 12.3085C6.7002 11.8585 7.0752 11.4085 7.5252 11.4085C7.9752 11.4085 7.9752 11.4835 8.2002 11.7085C8.8002 12.3085 9.4752 12.6835 10.3752 12.6835C11.2752 12.6835 11.5752 12.3835 11.5752 11.8585C11.5752 11.3335 11.2002 11.1835 10.7502 11.1085L9.1752 10.8085C7.7502 10.5085 7.0002 9.83354 7.0002 8.48354C7.0002 7.13354 7.9752 6.15854 9.4752 5.93354V5.40854C9.4752 4.88354 9.8502 4.50854 10.3002 4.50854C10.7502 4.50854 11.1252 4.88354 11.1252 5.40854V5.93354C11.7252 6.08354 12.2502 6.30854 12.6252 6.53354C13.1502 6.83354 13.3752 7.35854 13.3752 7.80854C13.3752 8.25854 13.0752 8.63354 12.6252 8.63354C12.1752 8.63354 12.0252 8.48354 11.7252 8.25854C11.3502 7.88354 10.7502 7.50854 9.9252 7.50854C9.1002 7.50854 8.8002 7.73354 8.8002 8.25854C8.8002 8.78354 9.1752 8.93354 9.7752 9.00854L11.2752 9.38354C12.4752 9.68354 13.4502 10.1335 13.4502 11.7085C13.4502 13.2835 12.5502 13.9585 11.1252 14.2585V14.7835C11.1252 15.3085 10.7502 15.6835 10.3002 15.6835C9.8502 15.6835 9.4752 15.3085 9.4752 14.7835L9.4002 14.8585Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0498 2.4834H17.9498",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.45 2.4834H3.625V18.0084H16.45V2.4834Z",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7137_2428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1.2085)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/Earn.70ebd84d390a351b2eabdf4f8bf840f9.svg";
export { ForwardRef as ReactComponent };